import styled from 'styled-components';
export const DatepickerWrapper = styled.div `
  position: relative;
`;
export const DatepickerInput = styled.div `
  display: flex;
  box-sizing: border-box;
  height: 42px;
  width: 100%;
  border: none;
  outline: none;
  padding: 11px 10px;
  cursor: pointer;
  line-height: 20px;
  border: 1px solid ${props => (props.error && !props.disabled) ? props.theme.colors.error : props.theme.input.borderColors.default};
  color: ${props => props.theme.input.normal.textColor};
  background: ${props => props.theme.input.normal.backgroundColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &[disabled] {
    cursor: not-allowed;
  }
  ${props => !props.error && `
    &:focus {
      border: 1px solid ${props.theme.input.borderColors.focus};
    }
    &:not([disabled]):hover {
      border-color: ${props.theme.input.borderColors.hover};
    }
  `}
`;
export const DatepickerLabel = styled.div `
  color: ${props => props.theme.input[props.disabled ? 'disabled' : 'normal'].textColor};
  background-color: ${props => props.theme.input[props.disabled ? 'disabled' : 'normal'].backgroundColor};
  display: inline-block;
  pointer-events: none;
  font-size: 14px; 
  padding: 0 5px 0 5px;
  line-height: 16px;
  font-weight: 600;
  color: #000;
  position: absolute;
  top: 0;
  left: 5px;
  z-index: 2;
  background-color: ${props => props.theme.input.normal.backgroundColor};
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 95%;
  @media screen and (max-width: 450px) {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 140px;
  }
`;
export const DatepickerExpandIcon = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DatepickerPlaceholder = styled.div `
  flex-grow: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: lowercase;
  color:  ${props => props.isSelected ? 'black' : props.theme.input.disabled.textColor};
`;
